import * as React from 'react';
import { CreateTeamDialogModel } from './model/TeamModel';
import { TeamController } from './controller/TeamController';
import { Dialog } from 'components/dialog';
import { TextField } from 'components/input/TextField';
import { Button } from '@material-ui/core';

export class CreateTeamDialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = { name: props.model.name };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleCancelButtonClicked = this.handleCancelButtonClicked.bind(this);
        this.handleCreateButtonClicked = this.handleCreateButtonClicked.bind(this);
    }

    private handleNameChange(newValue: string) {
        this.setState({ name: newValue });
    }

    private handleCancelButtonClicked() {
        this.props.controller.onCreateTeamCancelClicked();
    }

    private handleCreateButtonClicked() {
        this.props.controller.onCreateTeamSaveClicked(this.state.name);
    }

    public render() {
        return (
            <Dialog title="Create team" desc="Fill the form below to create a new team!">
                <TextField label="Name" value={this.state.name} desc="The name of the new team." error={this.props.model.nameError} onChange={this.handleNameChange} />
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.handleCreateButtonClicked}>Create</Button>
                </div>
            </Dialog>
        );
    }

}

export interface Props {

    model: CreateTeamDialogModel;
    controller: TeamController;

}

interface State {

    name: string;

}
